import React from "react";
import { createSvgIcon } from "@mui/material";

// The panel-outline toggle most apps use. @mui/icons-material has no left-panel
// glyph (ViewSidebar reads as a list), so it is drawn here as a Material-style path.
// Shared by the dashboard sidebar and CareMap's.
const SidebarIcon = createSvgIcon(
  <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 2v14h4V5H5zm6 0v14h8V5h-8z" />,
  "Sidebar"
);

export default SidebarIcon;
